module.exports = __webpack_public_path__ + "img/金属材料学9_6.68259a0e.png";